import Button from "components/ui/button";
import Modal from "components/ui/modal";
import React, { useState, useEffect } from "react";

const SalaryModal = ({ isOpen, onClose, salary, onSave }) => {
    console.log("SalaryModal salary prop:", salary);
  const [formData, setFormData] = useState({
    basic_salary: 0,
    hra: 0,
    da: 0,
    special_allowance: 0,
    performance_incentive: 0,
    annual_bonus: 0,
    pf_employee: 0,
    esi_employee: 0,
    tax_deduction: 0,
    other_deductions: 0,
    month: "",
    remarks: "",
  });

  useEffect(() => {
    if (salary) {
      // If salary is from defaults (create mode), merge into formData
      setFormData((prev) => ({ ...prev, ...salary }));
    }
  }, [salary]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: name === "month" ? value : Number(value) || 0 }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-lg font-bold mb-4">{salary?.id ? "Update Salary" : "Create Salary"}</h2>
      <form onSubmit={handleSubmit} className="space-y-2">
        {Object.keys(formData).map(
          (key) =>
            key !== "lop_deduction" && (
              <div key={key} className="flex flex-col">
                <label className="text-sm font-medium">{key.replace("_", " ")}</label>
                <input
                  type={key === "month" ? "month" : "number"}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  className="border rounded p-1"
                  required={key !== "remarks"}
                />
              </div>
            )
        )}
        <div className="flex justify-end mt-4 space-x-2">
          <Button type="button" onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button type="submit">{salary?.id ? "Update" : "Create"}</Button>
        </div>
      </form>
    </Modal>
  );
};

export default SalaryModal;
